"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./SimpleGradientButton.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimpleGradientButton = function SimpleGradientButton(_ref) {
  var _ref$customClasses = _ref.customClasses,
      customClasses = _ref$customClasses === void 0 ? [] : _ref$customClasses,
      href = _ref.href,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("a", {
    href: href,
    className: "simple-gradient-button ".concat(customClasses.join(' '))
  }, children);
};

var _default = SimpleGradientButton;
exports.default = _default;